module.exports = __webpack_public_path__ + "static/hkgrotesk-mediumitalic-abd5a23be214c71b6da3816296a8d1ea.woff";